/**
The main entry point for the Strava partnership.

Referenced by the page.strava.liquid template.
* */
import ReactDOM from 'react-dom';
import './apps/pages/strava/global.scss';
import { StravaRightBottom, StravaLeft, StravaRightTop } from './apps/pages/strava';
import OVApp from './utils/OVContext';
import { jsx as _jsx } from "react/jsx-runtime";

function init() {
  ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
    children: /*#__PURE__*/_jsx(StravaLeft, {})
  }), document.getElementById('strava-left'));
  ReactDOM.render( /*#__PURE__*/_jsx(StravaRightBottom, {}), document.getElementById('strava-right-bottom'));
  ReactDOM.render( /*#__PURE__*/_jsx(StravaRightTop, {}), document.getElementById('strava-right-top'));
}

init();